import {StaffListProps} from "./types";
import React, {FC} from "react";
import type {MenuProps} from "antd";
import {Button, Dropdown, Empty, Skeleton} from "antd";
import "./style.less"
import StaffDetailModal from "../modals/staffDetails-modal/StaffDetailModal";
import CreateStaffModal from "../modals/createStaff-modal/CreateStaffModal";
import {STAFF_ROLES} from "../../enums/staffRoles";
import {getImageLink} from "../../helpers/mainHelpers";
import * as BUCKETS from "../../enums/buckets";
import CreateFeedbackModal from "../modals/feedback-modal/FeedbackModal";
import {StaffItem} from "../../types/staff";
import {
  DeleteOutlined,
  EditOutlined,
  MessageOutlined,
  MoreOutlined,
  RightOutlined,
  UserOutlined
} from "@ant-design/icons";
import {useAuth} from "../../context/authContext";

const StaffList: FC<StaffListProps> = ({staffController}) => {
  const {staffList, confirmDeleteStaff, editStaffButtonHandler, isLoading} = staffController
  const {canManageContent} = useAuth()

  const showStaffDetail = (staff: StaffItem) => {
    staffController.toggleDetailModal({selectedStaff: staff, isModalOpen: true})
  }

  const openFeedbackModal = (staff: StaffItem) => {
    staffController.setSelectedStaff(staff)
    staffController.toggleCreateFeedbackModal()
  }

  const getAdminMenu = (staff: StaffItem): MenuProps["items"] => [
    {key: "edit", icon: <EditOutlined/>, label: "Редагувати", onClick: () => editStaffButtonHandler(staff)},
    {
      key: "delete",
      danger: true,
      icon: <DeleteOutlined/>,
      label: "Видалити",
      onClick: () => confirmDeleteStaff({staffId: staff.$id || "", staffName: staff.fullName})
    },
  ]

  return <div className="departmentStaff_list">
    {isLoading && staffList.length === 0
      ? <div className="staff-grid staff-grid--loading" aria-label="Завантаження лікарів">
        {[0, 1, 2, 3].map((item) => <div className="staff-skeleton" key={item}>
          <Skeleton.Image active/>
          <Skeleton active paragraph={{rows: 2}} title={{width: "72%"}}/>
        </div>)}
      </div>
      : staffList.length === 0
        ? <div className="staff-list-empty"><Empty description="Лікарів ще не додано"/></div>
        : <div className={`staff-grid ${isLoading ? "staff-grid--updating" : ""}`}>
          {staffList.map((staff) => <article className="staff-card" key={staff.$id || staff.fullName}>
            <button className="staff-card__profile" type="button" onClick={() => showStaffDetail(staff)}
                    aria-label={`Докладніше про лікаря: ${staff.fullName}`}>
              <div className="staff-card__portrait">
                {staff.image
                  ?
                  <img className="staff-card__image" src={getImageLink({imageId: staff.image, bucketId: BUCKETS.MAIN})}
                       alt={`Фото: ${staff.fullName}`} loading="lazy"/>
                  : <div className="staff-card__placeholder" aria-hidden="true"><UserOutlined/></div>}
                {staff.appointmentAvailable && <span className="staff-card__available">Доступний запис</span>}
              </div>
              <div className="staff-card__content">
                <h3 className="staff-card__name">{staff.fullName}</h3>
                <p className="staff-card__position">{staff.position}</p>
                <span className="staff-card__more">Детальніше <RightOutlined/></span>
              </div>
            </button>

            <button className="staff-card__feedback" type="button" onClick={() => openFeedbackModal(staff)}>
              <MessageOutlined/>Поділитися враженнями
            </button>

            {canManageContent && <Dropdown menu={{items: getAdminMenu(staff)}} trigger={["click"]}>
                <Button className="staff-card__admin" type="text" shape="circle" icon={<MoreOutlined/>}
                        aria-label={`Керування лікарем: ${staff.fullName}`}/>
            </Dropdown>}
          </article>)}
        </div>}

    <StaffDetailModal staffController={staffController}/>
    <CreateStaffModal staffRole={STAFF_ROLES.DOCTOR} staffController={staffController}/>
    <CreateFeedbackModal staffController={staffController}/>
  </div>
}

export default StaffList
